import { useGoogleMap } from "@react-google-maps/api";
import { useEffect, useMemo } from "react";
import { createPortal } from "react-dom";

type MapControlProps = {
  position: google.maps.ControlPosition;
  children: React.ReactNode;
};

export const MapControl = ({ children, position }: MapControlProps) => {
  const controlContainer = useMemo(() => document.createElement("div"), []);
  const map = useGoogleMap();

  useEffect(() => {
    if (!map) return;

    const controls = map.controls[position];

    controls.push(controlContainer);

    return () => {
      const controlsArray = controls.getArray();
      // controlsArray could be undefined if the map is in an undefined state (e.g. invalid API-key, see #276
      if (!controlsArray) return;

      const index = controlsArray.indexOf(controlContainer);
      controls.removeAt(index);
    };
  }, [controlContainer, map, position]);

  return createPortal(children, controlContainer);
};
